export const GET_OPEN_JOBS = "GET_OPEN_JOBS"
export const GET_OPEN_JOBS_SUCCESS = "GET_OPEN_JOBS_SUCCESS"
export const GET_OPEN_JOBS_FAILURE = "GET_OPEN_JOBS_FAILURE"